import {Login} from '@/soganhei'

import http from "@/http/service"
 
export default function LoginAdmin(payload=Login){

    const {login, senha} = payload

    const usuario = {
        login, 
        senha, 
    }
    
    return http.post(`/auth/usuario`,usuario)

}